import * as React from 'react';

interface CorrectionMetadataProps {
    principalInvestigator: string;
    site: string;
    subject: string;
    visit: string;
    session: string;
}

export const CorrectionMetadata = (props: CorrectionMetadataProps) => {
    const metadata = [
        { Title: 'Site', Content: props.site },
        { Title: 'Principal Investigator', Content: props.principalInvestigator },
        { Title: 'Subject', Content: props.subject },
        { Title: 'Visit', Content: props.visit },
        { Title: 'Session', Content: props.session },
    ]

    return (
        <>
            {metadata.map(x => {
                return (
                    <React.Fragment key={`Metadata${x.Title}`}>
                        <div className="row">
                            <div className="col-sm-6">
                                <h4>{x.Title}</h4>
                            </div>
                            <div className="col-sm-6 pull-right" style={{ overflow: "auto" }}>
                                {x.Content}
                            </div>
                        </div>
                        <hr />
                    </React.Fragment>
                );
            })}
        </>
    )
}
